import { MaintenanceLockViewModel } from '@mp/system/maintenance/domain';

import { formatCountdown } from './format-countdown';
import { parseUtcTimestamp } from './parse-utc-timestamp';

/**
 * Builds the view model of the maintenance lock.
 * @param input The known window data and the corrected current time.
 * @param input.announcementText The announcement text of the running window, if set.
 * @param input.endUtc The end of the running window as UTC timestamp, if known.
 * @param input.canSwitchOrganization Whether the user is assigned to more than one organization.
 * @param input.correctedNow The current time (epoch milliseconds) corrected by the server time offset.
 * @returns The view model of the lock.
 */
export function buildMaintenanceLockViewModel(input: {
  readonly announcementText: string | null;
  readonly endUtc: string | null;
  readonly canSwitchOrganization: boolean;
  readonly correctedNow: number;
}): MaintenanceLockViewModel {
  const { announcementText, endUtc, canSwitchOrganization, correctedNow } = input;
  const end = parseUtcTimestamp(endUtc);

  return {
    announcementText,
    countdown: formatCountdown(end === null ? null : end - correctedNow),
    canSwitchOrganization,
  };
}
